import { use_slice_generation } from '@/hooks/store/use_slices';
import { useReactFlow } from '@xyflow/react'; // Assuming standard xyflow hooks
import { useEffect } from 'react'; // Standard React hooks convention, assuming use_effect aliases useEffect

export function WATCHER__xyflow_fit_view() {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { fitView } = useReactFlow();

  useEffect(() => {
    // Fits the view to the current nodes/edges when the tool name changes
    fitView({ padding: 0.2, duration: 300 });
  }, [generation_current.tool.name, fitView]);

  return null;
}
